import { ReqBodyType } from '../types/reqBody';
import HttpClient from '../utils/HttpClient';

interface VehiclesServiceInterface {
  codEmpresa?: number;
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  codVeiculoSis?: string;
  codLocTrab?: number;
  usuario?: string;
  consumo?: number;
  reqBody?: ReqBodyType;
}

class VehiclesService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listVehicles = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
  }: VehiclesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_FretaCadVeiculo?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}`,
    });
  };

  getVehicle = async ({
    codUsu,
    codVeiculoSis,
    perfilUsu,
    codEmpresa,
    token,
  }: VehiclesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_FretaCadVeiculoAcao?codUsu=${codUsu}&codVeiculoSis=${codVeiculoSis}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };

  getWorkplaces = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
  }: VehiclesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_FretaCadVeiculoAlt?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  getLines = async ({
    codLocTrab,
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
  }: VehiclesServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_LinhasFreta?codLocTrab=${codLocTrab}&codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };

  createVehicle = async ({
    codUsu,
    perfilUsu,
    usuario,
    codEmpresa,
    token,
    reqBody,
  }: VehiclesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_FretaCadVeiculo?codUsu=${codUsu}&perfilUsu=${perfilUsu}&usuario=${usuario}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };

  updateVehicle = async ({
    codUsu,
    usuario,
    perfilUsu,
    codEmpresa,
    token,
    codVeiculoSis,
    consumo,
    reqBody,
  }: VehiclesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_FretaCadVeiculoAlt?codUsu=${codUsu}&usuario=${usuario}&codVeiculoSis=${codVeiculoSis}&consumo=${consumo}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
      reqBody,
    });
  };

  deleteVehicle = async ({
    codUsu,
    perfilUsu,
    usuario,
    codVeiculoSis,
    codEmpresa,
    token,
  }: VehiclesServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_FretaCadVeiculoAcao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&usuario=${usuario}&codVeiculoSis=${codVeiculoSis}&codEmpresa=${codEmpresa}`,
    });
  };
}

export default new VehiclesService();
